import { ReportSdk } from 'lib-klab-sdks';
import {
    ScreenshotReportItem,
    ScreenshotReportMetadata,
    ScreenshotReportPage,
    ScreenshotReportResponse,
} from '../../../domain/models/reports/screenshot-report.model';
import { ScreenshotDateRange } from '../../../domain/models/reports/request/screenshot-report.request';

export function mapSdkScreenshotDateRangeToDomain(
    dateRange?: ReportSdk.DateRange,
): ScreenshotDateRange | undefined {
    if (!dateRange) return undefined;
    return {
        startDate: dateRange.startDate,
        endDate: dateRange.endDate ?? '',
    };
}

export function mapSdkScreenshotMetadataToDomain(
    metadata?: ReportSdk.ScreenshotReportsResponseMetadata,
): ScreenshotReportMetadata {
    return {
        search: metadata?.search,
        dateRange: mapSdkScreenshotDateRangeToDomain(metadata?.dateRange),
        startTime: metadata?.startTime,
        endTime: metadata?.endTime,
        timeZone: metadata?.timeZone,
    };
}

export function mapSdkScreenshotPageToDomain(page?: ReportSdk.PaginationResponse): ScreenshotReportPage {
    return {
        page: page?.page ?? 0,
        size: page?.size ?? 0,
        totalElements: page?.totalElements ?? 0,
        totalPages: page?.totalPages ?? 0,
    };
}

export function mapSdkScreenshotItemToDomain(item: ReportSdk.ScreenshotItem): ScreenshotReportItem {
    return {
        screenshotId: item.screenshotId ?? 0,
        workSessionId: item.workSessionId ?? '',
        capturedAt: item.capturedAt ?? '',
        capturedAtLocal: item.capturedAtLocal,
        downloadUrl: item.downloadUrl ?? '',
    };
}

export function mapSdkScreenshotItemsToDomain(items: ReportSdk.ScreenshotItem[] | null | undefined): ScreenshotReportItem[] {
    return (items ?? []).map(mapSdkScreenshotItemToDomain);
}

export function mapSdkScreenshotReportsResponseToDomain(
    response: ReportSdk.ScreenshotReportsResponse,
): ScreenshotReportResponse {
    return {
        metadata: mapSdkScreenshotMetadataToDomain(response?.metadata),
        content: mapSdkScreenshotItemsToDomain(response?.content),
        page: mapSdkScreenshotPageToDomain(response?.page),
    };
}
